export default __webpack_public_path__ + "static/media/gift.cd5685a0.png";